import React, { useEffect, useState } from 'react'
import StepOne from './stepone';
import StepTwo from './steptwo';
import StepThree from './stepthree';
import StepFour from './stepfour';
import StepSix from './stepsix';
import StepFive from './stepfive';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next'

export default function VerificationSteps({ setuserFirstTime }) {
    const { t } = useTranslation("mediumBooking");
    const { step_progress } = useSelector(
        (state) => state.user.user
    );
    const [step, setStep] = useState(0);
    const activestep = localStorage.getItem('step')
    const navigate = useNavigate()
    const stepInfo = [
        { label: 'Zoom', title: 'Connect Zoom' },
        { label: 'Calendar', title: 'Connect Calendar' },
        { label: 'Testing', title: 'Test Connections' },
        { label: 'Appointments', title: 'Learn Appointments' },
        { label: 'Schedule', title: 'Make a Schedule' },
        { label: 'Practice', title: 'Book a Practice' },
    ];

    const NextStep = () => step !== 5 && setStep(step + 1);
    const PreviousStep = () => step !== 0 && setStep(step - 1);

    useEffect(() => {

        setStep(Object.values(step_progress).lastIndexOf(1) + 1);
    }, [])
    const innerWidthHandler = () => {
        return "100%";
      };
    const RenderedComponent = () => {
        switch (step) {
            case 0:
                return (
                    <StepOne
                        NextStep={NextStep}
                        innerWidthHandler={innerWidthHandler}
                    />
                );
            case 1:
                return (
                    <StepTwo
                        NextStep={NextStep}
                        innerWidthHandler={innerWidthHandler}
                    />
                );
            case 2:
                return (
                    <StepThree
                        NextStep={NextStep}
                        innerWidthHandler={innerWidthHandler}
                    />
                )
            case 3:
                return (
                    <StepFour
                        NextStep={NextStep}
                        innerWidthHandler={innerWidthHandler}
                    />
                )
            case 4:
                return (
                    <StepFive
                        NextStep={NextStep}
                        innerWidthHandler={innerWidthHandler}
                    />
                )
            case 5:
                return (
                    <StepSix
                    setuserFirstTime={setuserFirstTime}
                        NextStep={NextStep}
                        innerWidthHandler={innerWidthHandler}
                    />
                )
            default:
                return (
                    <></>
                )
        }
    }
    const stepHandler = (stepNum) => {
        setStep(stepNum)
    }
    const checkStep = (move) => {
        if (move > activestep) {
            return;
        }
        else {
            stepHandler(move);
        }
    }
    return (
        <div className="medium-booking-container onboarding-shell">
            {console.log(activestep, "activestep", step)}
            {/* <span
                className="back-handler pointer medium-booking-container-back-btn"
                onClick={() => {
                    navigate('/appointments');
                }}
            >
                <img src="../images/arrow-back.png" alt="go back" />&nbsp;
                Go Back
            </span> */}
            <div className="background-unset">
                <div className="row justify-content-center g-4">
                    <div className="col-12">
                        <div id="msform" className="w-100">
                            <div className="onboarding-progress-card">
                                <div className="onboarding-progress-header">
                                    <div className="onboarding-progress-copy">
                                        <h2>{t("steps.onboardingTitle")}</h2>
                                        <p>{t("steps.onboardingIntro")}</p>
                                    </div>
                                </div>
                                <div className="onboarding-steps-wrap">
                                    <ul id="progressbar" className="onboarding-step-grid">
                                        {stepInfo.map((item, index) => (
                                            <li
                                                key={item.title}
                                                className={`onboarding-step-item ${step > index ? "active" : ""} ${step === index ? 'current-active' : ''}`}
                                                id={`onboarding-step-${index + 1}`}
                                            >
                                                <span
                                                    className="onboarding-step-circle"
                                                    onClick={() => { checkStep(index) }}
                                                >
                                                    <img
                                                        src="images/privacy.png"
                                                        className="black"
                                                        alt="dark"
                                                    />
                                                    <img
                                                        src="images/privacy-wight.png"
                                                        className="wight"
                                                        alt="light"
                                                    />
                                                </span>
                                                {step > index ? (
                                                    <div className='step-image-box onboarding-step-text'>
                                                        <img className='w-20-px mr-2' src="./images/tick-marks.png" alt={t("steps.completed")} />
                                                        <strong className='onboarding-step-title'>{t("steps.stepNumber", { number: index + 1 })}</strong>
                                                    </div>
                                                ) : (
                                                    <div className='onboarding-step-text'>
                                                        <strong className='onboarding-step-title'>{t("steps.stepNumber", { number: index + 1 })}</strong>
                                                    </div>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                            <div className="onboarding-content-card mt-4">
                                <div className="body-from from-step-new">{RenderedComponent()}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
